import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatsCardProps {
  icon: LucideIcon;
  label: string;
  value: string | number;
  iconColor?: string;
  className?: string;
}

const StatsCard = ({ icon: Icon, label, value, iconColor = "text-primary", className = "" }: StatsCardProps) => {
  return (
    <Card className={`shadow-soft border-border/50 ${className}`}>
      <CardContent className="pt-6 text-center">
        <Icon className={`w-8 h-8 ${iconColor} mx-auto mb-2`} />
        <div className="text-2xl font-bold">{value}</div>
        <div className="text-xs text-muted-foreground">{label}</div>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
